import React, { useEffect } from "react";
import Header from '../header';

export default function Navbar(props) {
  useEffect(() => {
    const handleScroll = () => {
      const fixed_nav = document.querySelector(".fixed-navbar");
      if (window.scrollY > 50) {
        fixed_nav.classList.add("active");
      } else {
        fixed_nav.classList.remove("active");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="fixed-navbar">
      <Header hClass={props.hClass} />
    </div>
  );
}